import React, { useState, useEffect } from "react";
import { FaTimes, FaSave } from "react-icons/fa";
import apiRoutes from "../../../api/apiRoutes";
import { appFetchJson } from "../../../utils/http";

export default function CrearEstado({
  onClose = () => {},
  onCreated = () => {},
}) {
  const [descripcion, setDescripcion] = useState("");
  const [tipoEstadoId, setTipoEstadoId] = useState("");
  // Campos obligatorios completos → el formulario es válido
  const isValid = descripcion.trim() !== "" && tipoEstadoId !== "";

  const [tipos, setTipos] = useState([]);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState("");

  // === 1) Cargar tipos reales de estado ===
  useEffect(() => {
    const loadTipos = async () => {
      try {
        const url = apiRoutes.estadoTipo.listUrl({ page: 0, size: 100 });
        const res = await appFetchJson(
          url,
          { method: "GET" },
          { showLoading: false },
        );

        // ListPageDto -> items
        setTipos(res.items || []);
      } catch (e) {
        console.error("Error cargando tipos de estado:", e);
      }
    };

    loadTipos();
  }, []);

  // Cerrar con ESC
  useEffect(() => {
    const onKey = (e) => e.key === "Escape" && onClose();
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [onClose]);

  // === 2) Guardar real ===
  const guardar = async () => {
    setError("");

    if (!isValid) return; // No guardar si no está todo completo

    const payload = {
      nombre: descripcion.trim(),
      estadoTipoId: Number(tipoEstadoId),
    };

    try {
      setSaving(true);

      const nuevo = await appFetchJson(
        apiRoutes.estado.create,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(payload),
        },
      );

      // Notificamos al padre para refrescar la lista
      onCreated(nuevo);
      onClose();
    } catch (e) {
      console.error(e);
      setError("Ocurrió un error al guardar.");
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="modal-backdrop" onClick={onClose}>
      <div className="modal-panel-md" onClick={(e) => e.stopPropagation()}>
        {/* HEADER */}
        <div className="modal-header flex justify-between items-center">
          <h2 className="section-title">Crear Estado</h2>
          <button className="modal-close-x" onClick={onClose}>
            <FaTimes />
          </button>
        </div>

        {/* BODY */}
        <div className="modal-body">
          <div className="form-grid">
            {/* Descripción */}
            <div className="form-row">
              <label className="form-label">Descripción *</label>
              <input
                type="text"
                className="input"
                placeholder="Ej: CLIENTE ACTIVO"
                value={descripcion}
                onChange={(e) => setDescripcion(e.target.value)}
              />
            </div>

            {/* Tipo Estado */}
            <div className="form-row">
              <label className="form-label">Estado Tipo *</label>
              <select
                className="input"
                value={tipoEstadoId}
                onChange={(e) => setTipoEstadoId(e.target.value)}
              >
                <option value="">--- Seleccione ---</option>

                {tipos.map((t) => (
                  <option key={t.id} value={t.id}>
                    {t.nombreTipoestado || t.nombre}
                  </option>
                ))}
              </select>
            </div>
          </div>
        </div>

        {/* FOOTER */}
        <div className="modal-footer">
          <div className="btn-row">
            <button
              type="button"
              className={`btn-fil btn-wide ${
                !isValid || saving ? "opacity-60 cursor-not-allowed" : ""
              }`}
              disabled={!isValid || saving}
              onClick={guardar}
              title={
                !isValid
                  ? "Complete todos los campos obligatorios"
                  : saving
                    ? "Guardando..."
                    : "Guardar"
              }
            >
              <FaSave className="inline mr-1" />
              {saving ? "Guardando…" : "Guardar"}
            </button>

            <button
              type="button"
              className="btn-fil btn-wide"
              onClick={onClose}
            >
              Cancelar
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
